/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { Util } from 'app/scripts/lib/util';
import type { Card } from 'app/scripts/models/Card';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { StickerView } from 'app/scripts/views/stickers/StickerView';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// @ts-expect-error
interface StickerEditView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editTraceId: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setTimeout: any;
}

class StickerEditView extends StickerView {
  static initClass() {
    this.prototype.events = {
      // @ts-expect-error TS(2322): Type '{ mouseenter: string; mouseleave: string; mo... Remove this comment to see the full error message
      mouseenter: 'mouseenter',
      mouseleave: 'mouseleave',
      mousedown: 'editSticker',
      'mousedown .js-remove-sticker': 'removeSticker',
      'mousedown .js-rotate-sticker': 'startRotate',
      'mousedown .js-move-sticker': 'startMove',
    };

    // @ts-expect-error TS(2339): Property 'editTraceId' does not exist on type 'typ... Remove this comment to see the full error message
    this.editTraceId = null;
  }

  initialize() {
    this.listenTo(this.model, 'stopEditing', this.stopEditing);
    this.listenTo(this.model, 'startEditing', this.editSticker);
    this.listenTo(this.model, 'disableEditing', this.disableEditing);
    return this.listenTo(this.model, 'enableEditing', this.enableEditing);
  }

  showEditControls() {
    return true;
  }

  disableEditing() {
    return this.$el.addClass('editing-disabled');
  }

  enableEditing() {
    return this.$el.removeClass('editing-disabled');
  }

  endCurrentEdit() {
    $(document).off('.stickerrotate .stickermove .stickerautomove');
    this.$el.removeClass('moving rotating');
    return $('.quick-card-editor').removeClass('invalid dragging');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stopEditing(e: any) {
    stopPropagationAndPreventDefault(e);

    if (this.isEditing()) {
      this.endCurrentEdit();
      this.$el.removeClass('editing');
      $('.quick-card-editor').removeClass('quick-card-editor-editing-stickers');
      return Array.from(this.model.collection.models).map((sticker) =>
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        sticker.trigger('enableEditing'),
      );
    }
  }

  isEditing() {
    return this.$el.is('.moving, .rotating, .editing');
  }

  isEditingDisabled() {
    return this.$el.is('.editing-disabled');
  }

  isMovingOrRotating() {
    return this.$el.is('.moving, .rotating');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saveStickerAttrs({ position, rotation }: any) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const round = (percent: any) => Math.round(percent * 100) / 100;

    const update = { zIndex: this.model.collection.nextZIndex(this.model) };

    if (position) {
      // eslint-disable-next-line @trello/enforce-variable-case
      const $card = this.$el.closest('.list-card');
      // eslint-disable-next-line @trello/enforce-variable-case
      const $stickers = $card.find('.js-card-stickers');
      const stickerAreaWidth = $stickers.width() as number;
      const stickerAreaHeight = $stickers.height() as number;

      // @ts-expect-error TS(2339): Property 'left' does not exist on type '{ zIndex: ... Remove this comment to see the full error message
      update.left = round(
        (parseFloat(this.$el.css('left')) / stickerAreaWidth) * 100,
      );
      // @ts-expect-error TS(2339): Property 'top' does not exist on type '{ zIndex: a... Remove this comment to see the full error message
      update.top = round(
        (parseFloat(this.$el.css('top')) / stickerAreaHeight) * 100,
      );
    }

    if (rotation) {
      const matrix = Util.getElemTransformMatrix(
        this.$el.find('.sticker-image'),
      );
      // @ts-expect-error TS(2339): Property 'rotate' does not exist on type '{ zIndex... Remove this comment to see the full error message
      update.rotate = round(Util.getMatrixDegrees(matrix) % 360);
    }

    this.model.update(
      {
        ...update,
        traceId: this.editTraceId,
      },
      tracingCallback(
        {
          taskName: 'edit-card/stickers',
          traceId: this.editTraceId,
          source: 'stickerEditView',
          attributes: {
            action: rotation ? 'rotated' : position ? 'moved' : 'edited',
          },
        },
        (_err, sticker) => {
          if (sticker) {
            const card = this.options?.card as Card;
            Analytics.sendUpdatedCardFieldEvent({
              field: 'stickers',
              source: 'stickerEditView',
              attributes: {
                taskId: this.editTraceId,
                action: rotation ? 'rotated' : position ? 'moved' : 'edited',
              },
              containers: {
                card: {
                  id: card?.id,
                },
                board: {
                  id: card?.get('idBoard'),
                },
                list: {
                  id: card?.get('idList'),
                },
              },
            });
          }
        },
      ),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseenter(e: any) {
    if (
      !(
        this.isEditingDisabled() ||
        this.isEditing() ||
        this.isMovingOrRotating()
      )
    ) {
      this.$el.addClass('hover');
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseleave(e: any) {
    this.$el.removeClass('hover');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editSticker(e: any) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let autoClear: any;
    if (e != null && e.which !== 1) {
      // Non-left-click
      return;
    }

    stopPropagationAndPreventDefault(e);

    if (e != null && e.type === 'mousedown') {
      // Hold on to the mouse position, in case they start dragging
      const { pageX: origX, pageY: origY } = e;

      const clear = () => {
        $(document).off('.stickerautomove');
        return clearTimeout(autoClear);
      };

      $(document).on('mousemove.stickerautomove', (event) => {
        // If they drag the cursor more than 5 px, they're probably trying to
        // drag
        if (
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          Math.pow(event.pageX - origX, 2) + Math.pow(event.pageY - origY, 2) >
          5 * 5
        ) {
          clear();
          return this.startMove(event);
        }
      });

      // Okay, it's a click, not a drag
      $(document).on('mouseup.stickerautomove', clear);

      // Just in case something goes wrong, clear the handlers after a second
      autoClear = this.setTimeout(clear, 1000);
    }

    // NOTE: We clone the array, so it doesn't get changed out from under us
    // when the models save
    const stickers = _.clone(this.model.collection.models);
    for (const otherSticker of Array.from(stickers)) {
      if (otherSticker !== this.model) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        otherSticker.trigger('stopEditing');
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        otherSticker.trigger('disableEditing');
      }
    }

    // Defer adding the class so the controls-popping-out animation works on the
    // first click (we have to have it be in the DOM in non-editing mode so we
    // can css-transition to editing mode)
    this.defer(() => {
      PopOver.hide();
      this.$el.addClass('editing');
      return $('.quick-card-editor').addClass(
        'quick-card-editor-editing-stickers',
      );
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  startRotate(e: any) {
    if (!this.isEditing()) {
      return;
    }

    e?.preventDefault();
    this.editTraceId = Analytics.startTask({
      taskName: 'edit-card/stickers',
      source: 'stickerEditView',
      attributes: {
        action: 'rotated',
      },
    });

    const stickerOrigin = {
      // @ts-expect-error
      x: this.$el.offset().left + this.$el.width() / 2,
      // @ts-expect-error
      y: this.$el.offset().top + this.$el.height() / 2,
    };

    const mousePosOrigin = {
      x: e.pageX,
      y: e.pageY,
    };

    let startRotate = 0;
    const matrix = Util.getElemTransformMatrix(this.$el.find('.sticker-image'));
    if (matrix != null) {
      startRotate = Util.getMatrixDegrees(matrix);
    }

    let didMove = false;

    $(document).on('mousemove.stickerrotate', (event) => {
      if (!didMove) {
        this.$el.removeClass('hover').addClass('rotating');

        $('.quick-card-editor').addClass('dragging');
        didMove = true;
      }

      const mousePos = {
        x: event.pageX,
        y: event.pageY,
      };

      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      const endX = mousePos.x - stickerOrigin.x;
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      const endY = mousePos.y - stickerOrigin.y;

      const mouseInitialRotate = Util.getDegrees(
        mousePosOrigin.y - stickerOrigin.y,
        mousePosOrigin.x - stickerOrigin.x,
      );
      const endRotate = Util.getDegrees(endY, endX);
      const deltaRotate = endRotate - mouseInitialRotate;

      const newRotate = startRotate + deltaRotate;

      this.$el.find('.sticker-image').css({
        transform: `rotate(${newRotate}deg)`,
        '-webkit-transform': `rotate(${newRotate}deg)`,
      });
    });

    $(document).on('mouseup.stickerrotate', () => {
      if (didMove) {
        this.saveStickerAttrs({ rotation: true });
        return this.endCurrentEdit();
      } else {
        return $(document).off('.stickerrotate');
      }
    });

    return false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  startMove(e: any) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let offsetX: any, offsetY: any;
    if (!this.isEditing()) {
      return;
    }

    stopPropagationAndPreventDefault(e);
    this.editTraceId = Analytics.startTask({
      taskName: 'edit-card/stickers',
      source: 'stickerEditView',
      attributes: {
        action: 'moved',
      },
    });
    // eslint-disable-next-line @trello/enforce-variable-case
    const $card = this.$el.closest('.list-card');
    // eslint-disable-next-line @trello/enforce-variable-case
    const $stickersArea = $card.find('.js-card-stickers');

    // @ts-expect-error
    const { left: parentLeft, top: parentTop } = $stickersArea.offset();
    const stickerWidth = this.$el.width();
    const stickerHeight = this.$el.height();
    const parentWidth = $stickersArea.width();
    const parentHeight = $stickersArea.height();

    const bounds = {
      left: -40,
      // @ts-expect-error
      right: parentWidth - 10,
      top: -40,
      // @ts-expect-error
      bottom: parentHeight - 10,
    };

    if (e != null) {
      // They clicked on the move handle, so hold that offset
      // @ts-expect-error
      offsetX = this.$el.offset().left + this.$el.width() / 2 - e.pageX;
      // @ts-expect-error
      offsetY = this.$el.offset().top + this.$el.height() / 2 - e.pageY;
    } else {
      offsetX = 0;
      offsetY = 0;
    }

    let didMove = false;

    $(document).on('mousemove.stickermove', (event) => {
      if (!didMove) {
        this.$el.removeClass('hover').addClass('moving');

        $('.quick-card-editor').addClass('dragging');

        didMove = true;
      }

      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      let newLeft = event.pageX - parentLeft - stickerWidth / 2 + offsetX;
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      let newTop = event.pageY - parentTop - stickerHeight / 2 + offsetY;

      let valid = true;
      if (newLeft > bounds.right) {
        newLeft = bounds.right;
        valid = false;
      }

      if (newLeft < bounds.left) {
        newLeft = bounds.left;
        valid = false;
      }

      if (newTop > bounds.bottom) {
        newTop = bounds.bottom;
        valid = false;
      }

      if (newTop < bounds.top) {
        newTop = bounds.top;
        valid = false;
      }

      $('.quick-card-editor').toggleClass('invalid', !valid);

      return this.$el.css({
        left: newLeft,
        top: newTop,
      });
    });

    $(document).on('mouseup.stickermove', () => {
      if (didMove) {
        this.saveStickerAttrs({ position: true });
        return this.endCurrentEdit();
      } else {
        return $(document).off('.stickermove');
      }
    });

    return false;
  }

  // @ts-expect-error TS(2425): Class 'StickerView' defines instance member proper... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeSticker(e: any) {
    if (this.isEditing()) {
      const remove = _.once(() => {
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        this.stopEditing();
        this.model.destroyWithTracing(
          {
            traceId: this.editTraceId,
          },
          tracingCallback(
            {
              taskName: 'edit-card/stickers',
              traceId: this.editTraceId,
              source: 'stickerEditView',
              attributes: {
                action: 'removed',
              },
            },
            (_err, sticker) => {
              if (sticker) {
                const card = this.options?.card as Card | undefined;
                Analytics.sendUpdatedCardFieldEvent({
                  field: 'stickers',
                  source: 'stickerEditView',
                  attributes: {
                    taskId: this.editTraceId,
                    action: 'removed',
                  },
                  containers: {
                    card: {
                      id: card?.id,
                    },
                    board: {
                      id: card?.get('idBoard'),
                    },
                    list: {
                      id: card?.get('idList'),
                    },
                  },
                });
              }
            },
          ),
        );
        this.$el.remove();
      });

      this.$el.one('transitionEnd webkitTransitionEnd', remove);

      this.setTimeout(remove, 100);

      this.$el.addClass('fade-out');
    }
  }
}

StickerEditView.initClass();
export { StickerEditView };
